export interface MasterBarcodeGroupTheme {
  key: string;
  sectionBorder: string;
  sectionBackground: string;
  cardBorder: string;
  cardBackground: string;
  upcText: string;
  supportingText: string;
  nestedRail: string;
  nestedSurface: string;
  badgeBackground: string;
  badgeBorder: string;
  badgeText: string;
}

const MASTER_BARCODE_GROUP_THEMES: MasterBarcodeGroupTheme[] = [
  {
    key: 'deep-sky',
    sectionBorder: '#4ea8de',
    sectionBackground: 'rgba(78, 168, 222, 0.11)',
    cardBorder: 'rgba(78, 168, 222, 0.34)',
    cardBackground: 'rgba(232, 246, 255, 0.84)',
    upcText: 'rgba(15, 23, 42, 0.92)',
    supportingText: 'rgba(15, 23, 42, 0.7)',
    nestedRail: 'rgba(78, 168, 222, 0.42)',
    nestedSurface: 'rgba(238, 248, 255, 0.7)',
    badgeBackground: '#3b82c4',
    badgeBorder: '1px solid rgba(186, 225, 255, 0.85)',
    badgeText: '#f8fdff',
  },
  {
    key: 'seafoam',
    sectionBorder: '#38b2ac',
    sectionBackground: 'rgba(56, 178, 172, 0.12)',
    cardBorder: 'rgba(56, 178, 172, 0.3)',
    cardBackground: 'rgba(235, 252, 249, 0.85)',
    upcText: 'rgba(15, 23, 42, 0.92)',
    supportingText: 'rgba(15, 23, 42, 0.7)',
    nestedRail: 'rgba(56, 178, 172, 0.38)',
    nestedSurface: 'rgba(239, 252, 249, 0.72)',
    badgeBackground: '#2b8f8a',
    badgeBorder: '1px solid rgba(191, 245, 239, 0.85)',
    badgeText: '#f5fffe',
  },
  {
    key: 'amber',
    sectionBorder: '#d39b34',
    sectionBackground: 'rgba(211, 155, 52, 0.12)',
    cardBorder: 'rgba(211, 155, 52, 0.3)',
    cardBackground: 'rgba(255, 248, 231, 0.86)',
    upcText: 'rgba(15, 23, 42, 0.92)',
    supportingText: 'rgba(15, 23, 42, 0.7)',
    nestedRail: 'rgba(211, 155, 52, 0.38)',
    nestedSurface: 'rgba(255, 249, 237, 0.72)',
    badgeBackground: '#ba7d12',
    badgeBorder: '1px solid rgba(255, 229, 175, 0.88)',
    badgeText: '#fffaf0',
  },
  {
    key: 'coral',
    sectionBorder: '#de7f6f',
    sectionBackground: 'rgba(222, 127, 111, 0.12)',
    cardBorder: 'rgba(222, 127, 111, 0.31)',
    cardBackground: 'rgba(255, 241, 238, 0.85)',
    upcText: 'rgba(15, 23, 42, 0.92)',
    supportingText: 'rgba(15, 23, 42, 0.7)',
    nestedRail: 'rgba(222, 127, 111, 0.38)',
    nestedSurface: 'rgba(255, 244, 241, 0.72)',
    badgeBackground: '#c96553',
    badgeBorder: '1px solid rgba(255, 215, 208, 0.88)',
    badgeText: '#fff8f6',
  },
  {
    key: 'rose',
    sectionBorder: '#d06a9b',
    sectionBackground: 'rgba(208, 106, 155, 0.12)',
    cardBorder: 'rgba(208, 106, 155, 0.31)',
    cardBackground: 'rgba(255, 239, 246, 0.85)',
    upcText: 'rgba(15, 23, 42, 0.92)',
    supportingText: 'rgba(15, 23, 42, 0.7)',
    nestedRail: 'rgba(208, 106, 155, 0.38)',
    nestedSurface: 'rgba(255, 243, 248, 0.72)',
    badgeBackground: '#b94d81',
    badgeBorder: '1px solid rgba(255, 210, 229, 0.88)',
    badgeText: '#fff8fb',
  },
  {
    key: 'indigo',
    sectionBorder: '#7887d7',
    sectionBackground: 'rgba(120, 135, 215, 0.12)',
    cardBorder: 'rgba(120, 135, 215, 0.32)',
    cardBackground: 'rgba(240, 243, 255, 0.85)',
    upcText: 'rgba(15, 23, 42, 0.92)',
    supportingText: 'rgba(15, 23, 42, 0.7)',
    nestedRail: 'rgba(120, 135, 215, 0.39)',
    nestedSurface: 'rgba(244, 246, 255, 0.72)',
    badgeBackground: '#5c6dc8',
    badgeBorder: '1px solid rgba(209, 216, 255, 0.88)',
    badgeText: '#f8f9ff',
  },
];

export function getMasterBarcodeGroupTheme(index: number): MasterBarcodeGroupTheme {
  return MASTER_BARCODE_GROUP_THEMES[index % MASTER_BARCODE_GROUP_THEMES.length];
}
